"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiSubjectsClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
const SubjectsConverter_1 = require("../SubjectsConverter");
const expandUrlTemplate_1 = __importDefault(require("../../common/utils/expandUrlTemplate"));
class ApiSubjectsClient extends ApiSubClient_1.ApiSubClient {
    async getAll() {
        const subjectsLink = this.getLinkOrThrow('subjects');
        return this.axios
            .get(subjectsLink.href)
            .then((response) => response.data._embedded.subjects.map((it) => SubjectsConverter_1.SubjectsConverter.convert(it)));
    }
    async getMarketSegmentSubjects(marketSegment) {
        const subjectsLink = this.getLinkOrThrow('marketSegmentSubjects');
        const link = (0, expandUrlTemplate_1.default)(subjectsLink.href, {
            marketSegment,
        });
        return this.axios
            .get(link)
            .then((response) => response.data._embedded.subjects.map((it) => SubjectsConverter_1.SubjectsConverter.convert(it)));
    }
    async update(subject, updateRequest) {
        const validUpdateLink = subject?.links?.update;
        if (!validUpdateLink) {
            throw new Error('Update link not available');
        }
        await this.axios.put(subject.links.update.getOriginalLink(), updateRequest);
    }
}
exports.ApiSubjectsClient = ApiSubjectsClient;
//# sourceMappingURL=ApiSubjectsClient.js.map